module.exports = __webpack_public_path__ + "static/img/6221_phase_function_Paper_PointsHejduk_Prediction.b530422.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6221_phase_function_Paper_PointsHejduk_Prediction.png
// module id = N05m
// module chunks = 0